"use client";

import React from "react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { ContactPopover } from "@/features/contacts/components/ContactPopover";
import { EmailRecipient } from "../ClientEmailSelector";
import { User, Users, Mail, X } from "lucide-react";

interface RecipientChipsProps {
  recipients: EmailRecipient[];
  onRemove: (recipientId: string) => void;
}

export function RecipientChips({ recipients, onRemove }: RecipientChipsProps) {
  if (recipients.length === 0) return null;

  return (
    <div className="flex flex-wrap gap-2">
      {recipients.map((recipient) => (
        <div key={recipient.id} className="flex items-center">
          {recipient.type === "client" && recipient.client ? (
            <ContactPopover name={recipient.name || recipient.email} email={recipient.email}>
              <Badge variant="secondary" className="cursor-pointer hover:bg-secondary/80 pr-1">
                <User className="h-3 w-3 mr-1" />
                {recipient.name || recipient.email}
                <Button
                  type="button"
                  variant="ghost"
                  size="sm"
                  className="h-auto p-1 ml-1 hover:bg-destructive hover:text-destructive-foreground"
                  onClick={(e) => {
                    e.stopPropagation();
                    onRemove(recipient.id);
                  }} title="Close"
                >
                  <X className="h-3 w-3" />
                </Button>
              </Badge>
            </ContactPopover>
          ) : recipient.type === "hub_user" ? (
            <ContactPopover name={recipient.name || recipient.email} email={recipient.email}>
              <Badge variant="secondary" className="cursor-pointer hover:bg-secondary/80 pr-1">
                <Users className="h-3 w-3 mr-1" />
                {recipient.name || recipient.email}
                <Button
                  type="button"
                  variant="ghost"
                  size="sm"
                  className="h-auto p-1 ml-1 hover:bg-destructive hover:text-destructive-foreground"
                  onClick={(e) => {
                    e.stopPropagation();
                    onRemove(recipient.id);
                  }} title="Close"
                >
                  <X className="h-3 w-3" />
                </Button>
              </Badge>
            </ContactPopover>
          ) : (
            <ContactPopover name={recipient.email} email={recipient.email}>
              <Badge variant="outline" className="cursor-pointer hover:bg-accent pr-1">
                <Mail className="h-3 w-3 mr-1" />
                {recipient.email}
                <Button
                  type="button"
                  variant="ghost"
                  size="sm"
                  className="h-auto p-1 ml-1 hover:bg-destructive hover:text-destructive-foreground"
                  onClick={(e) => {
                    e.stopPropagation();
                    onRemove(recipient.id);
                  }} title="Close"
                >
                  <X className="h-3 w-3" />
                </Button>
              </Badge>
            </ContactPopover>
          )}
        </div>
      ))}
    </div>
  );
}
